<script>
  import { Link } from "svelte-routing";
  import { store } from "./auth.js";
  let username = "";
  let password = "";
  function handleSubmit() {
    $store = { username }; // simulate login
  }
</script>

<form on:submit|preventDefault={handleSubmit}>
  <h1 class="text-center text-gray-800 text-3xl">Login to Mallorca</h1>
  <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
    <div class="mb-4">
      <label class="block text-gray-800 text-sm font-bold mb-2" for="username">
        Username
      </label>
      <input
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-800"
        id="username"
        type="text"
        bind:value={username}
        placeholder="Username" />
    </div>
    <div class="mb-6">
      <label class="block text-gray-800 text-sm font-bold mb-2" for="password">
        Password
      </label>
      <input
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-800 mb-3"
        id="password"
        type="password"
        bind:value={password}
        placeholder="******************" />
    </div>
    <div class="flex items-center justify-between">
      <Link to="/"><button
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="submit">
        Sign In
      </button></Link>
      <a
        class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-700"
        href="#/forgot-password">
        Forgot Password?
      </a>
    </div>
  </div>
</form>
